import React from 'react';
import { Grid, Message } from 'semantic-ui-react';

const UnauthorizedPage = () => {
	return (
		<Grid
			centered
			stackable
			className="with-padding"
		>
			<Grid.Row>
				<Grid.Column>
					<Message negative>Unauthorized</Message>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default UnauthorizedPage;
